import React from 'react';
import PropTypes from 'prop-types';

/**
 * TemplateMetadataBar2 - Kompakte Metadaten-Leiste für Template Editor
 * 
 * Zeigt Name, Kurs und Beschreibung in einer kompakten Leiste.
 * Klick auf "Bearbeiten" öffnet Modal zum Editieren.
 * 
 * Usage:
 * <TemplateMetadataBar2
 *   name="JavaScript Basics"
 *   courseName="Frontend-Entwicklung"
 *   description="Grundlagen der JavaScript Programmierung"
 *   hasUnsavedChanges={true}
 *   onEdit={() => setShowMetadataModal(true)}
 * />
 */
export default function TemplateMetadataBar2({
  name,
  courseName,
  description,
  onEdit
}) {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-4">
      <div className="flex items-start justify-between gap-4">
        {/* Content */}
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <h2 className="text-lg font-semibold text-gray-900 dark:text-white truncate">
              {name || 'Unbenannte Vorlage'}
            </h2>
          </div>
          
          <div className="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
            {courseName ? (
              <>
                <span className="px-2 py-0.5 bg-primary-100 dark:bg-primary-900/30 text-primary-700 dark:text-primary-300 rounded text-xs font-medium">
                  {courseName}
                </span>
                {description && <span className="text-gray-300 dark:text-gray-600">•</span>}
              </>
            ) : (
              <>
                <span className="px-2 py-0.5 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400 rounded text-xs">
                  Kein Kurs
                </span>
                {description && <span className="text-gray-300 dark:text-gray-600">•</span>}
              </>
            )}
            {description && (
              <span className="truncate">{description}</span>
            )}
          </div>
        </div>

        {/* Edit Button */}
        <button
          onClick={onEdit}
          className="flex-shrink-0 px-3 py-1.5 text-sm text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg theme-transition"
        >
          Bearbeiten
        </button>
      </div>
    </div>
  );
}

TemplateMetadataBar2.propTypes = {
  name: PropTypes.string,
  courseName: PropTypes.string,
  description: PropTypes.string,
  onEdit: PropTypes.func.isRequired
};
